module.exports = new __parcel__URL__("epic.51b289d0.svg").toString();